<template>
	<div class="wr">
		<router-view />
	</div>
</template>
<script>
export default { name: 'PlacementSectionRoot' };
</script>
<style scoped>
.wr {
	position: relative;
	width: 100%;
	height: 100%;
}
.kit_list {
	width: 342px;
	position: relative;
	border: 1px solid #d3dae9 !important;
	border-top-width: 0px !important;
}
.mdA .kit_list {
	width: 280px;
}
</style>
